<template>
  <div class="accidental-renewal">
    <h2 class="h3 mb-2"><b>Worried about an accidental renewal?</b></h2>
    <p class="mb-4">
      We'll send you a reminder on <b class="text-brand-yellow">{{ reminderOn }}</b>, one week before your renewal.
    </p>

    <p class="text-muted mb-2">How that looks:</p>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons accidental-renewal__icon">bolt</span>
          <div>
            <p class="mb-0"><b>Keep your PRO+ access now</b></p>
            <p class="text-muted mb-0">Continue using PRO+ maps and features</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons accidental-renewal__icon">event</span>
          <div>
            <p class="mb-0"><b>{{ reminderOn }}</b></p>
            <p class="text-muted mb-0">Receive reminder</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3">
          <span class="material-icons accidental-renewal__icon">help_outline</span>
          <div>
            <p class="mb-0"><b>Make your decision then</b></p>
            <p class="text-muted mb-0">You can choose to cancel or keep using</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ reminderOn: string }>();
</script>

<style scoped lang="scss">
.accidental-renewal {
  &__icon {
    color: var(--text-muted, #b2b2b2);
  }
}

.text-brand-yellow {
  color: #caa300;
}
</style>
